import { styled } from '@mui/system';

const SectionWrapper = styled('div')({
    paddingTop: '50px',
    paddingBottom: 0
});

export default SectionWrapper;
